import * as types from "./actionTypes";
import initialState from "../store/initialState";
import { getLayout } from "../store/configureStore";
import mergeDeep from '../util/mergeDeep';
import * as DomainConstants from '../constants/DomainConstants';

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function loadDefaultLayout() {
	return function (dispatch) {

		let layout = mergeDeep({}, initialState.layout);
		layout.showVoortgangsrapportLayout = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadMijnDossierPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = "Mijn dossier";
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showVoortgangsrapportLayout = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadAanvraagBevestigingsLayout(title, subtitle, dossierId) {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId));
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadProjectPageLayout(title, subtitle, dossierId, initialisatieOK, dossierType, infrastructuurId, showBeads, disableTopNav) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;
		layout.disableTopNav = disableTopNav;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = false;
		layout.showBeads = showBeads;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadInfrastructuurDetailPageLayout(dossierId, initialisatieOK, infrastructuurId, showBeads) {
	return function (dispatch) {

		let layout = getLayout();
		layout.showTopNav = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getDisabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = false;
		layout.showBeads = showBeads;
		layout.disableTopNav = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadTestPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = "Overzicht";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadAanvraagPageLayout(title, subtitle, isNew, aanvraagPageSuffix, dossierId, initialisatieOK, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.pageHeaderIntro = "";
		layout.showTopNav = true;
		layout.showBeads = showBeads;

		layout.showSideNav = false;
		if (isNew) {
			layout.topNavTabSettings.dossierTab.disabled = false;
			layout.topNavTabSettings.dossierTab.urlSuffix = aanvraagPageSuffix;
			layout.topNavTabSettings.indienenTab.disabled = true;
		} else {
			layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		}

		return dispatch(layoutUpdated(layout));
	};
}

export function loadMinimaleEisenDossierPageLayout(title, subtitle, dossierId, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.showTopNav = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = true;
		layout.sideNavPrefix = "/minimaleeisen/" + dossierId;
		layout.showBeads = showBeads;
		layout.hideAlgemeenButton = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadFinancieelPageLayout(title, subtitle, dossierId, dossierType, infrastructuurId) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.showTopNav = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.disableTopNav = false;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.sideNavItems = ([
			{
				titel: DomainConstants.FinancieelTitels.FinancieleDuurzaamheid,
				items: [
					{
						titel: "Kosten",
						urlSuffix: "kosten"
					},
					{
						titel: "Opbrengsten",
						urlSuffix: "opbrengsten"
					},
					{
						titel: "Overzicht Kosten/Opbrengsten",
						urlSuffix: "overzicht"
					}
				]
			},
			{
				titel: DomainConstants.FinancieelTitels.FinancieleHaalbaarheid,
				items: [
					{
						titel: "Investeringen",
						urlSuffix: "investeringen"
					},
					{
						titel: "Financiering",
						urlSuffix: "financiering"
					}
				]
			}
		]);
		layout.showSideNav = false;
		layout.showSideNavFinancieel = true;
		layout.sideNavPrefix = "/financieel/" + dossierId;
		layout.showBeads = true;
		layout.hideAlgemeenButton = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadMinimaleEisenInfoPageLayout(title, subtitle, dossierId, dossierType) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.showTopNav = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, null, true));
		layout.showSideNav = true;
		layout.sideNavPrefix = "/minimaleeisen/" + dossierId;
		layout.hideAlgemeenButton = false;

		return dispatch(layoutUpdated(layout));
	};
}


export function loadKostOpbrengstEditPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.disableTopNav = true;
		layout.showSideNavFinancieel = false;
		return dispatch(layoutUpdated(layout));
	};
}

export function loadInvesteringEditPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.disableTopNav = true;
		layout.showSideNavFinancieel = false;
		return dispatch(layoutUpdated(layout));
	};
}


export function loadFinancierEditPageLayout(title, subtitle, dossierType) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.showTopNav = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;

		layout.disableTopNav = true;
		layout.showSideNavFinancieel = false;
		return dispatch(layoutUpdated(layout));
	};
}

export function loadMinimaleEisenInfrastructuurPageLayout(title, subtitle, dossierId, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.showSideNav = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.sideNavPrefix = "/minimaleeisen/" + dossierId;
		layout.showBeads = showBeads;
		layout.hideAlgemeenButton = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadBovenLokaliteitPerDossierPageLayout(title, subtitle, dossierId, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {
		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showSideNav = true;
		layout.showTopNav = true;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.sideNavPrefix = "/bovenlokaliteit/" + dossierId;
		layout.showBeads = showBeads;
		layout.hideAlgemeenButton = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadBovenLokaliteitInfoPageLayout(title, subtitle, dossierId, dossierType) {
	return function (dispatch) {
		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showSideNav = true;
		layout.showTopNav = true;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, null, true));
		layout.sideNavPrefix = "/bovenlokaliteit/" + dossierId;
		layout.hideAlgemeenButton = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadBovenLokaliteitPerInfrastructuurPageLayout(title, subtitle, dossierId, typeDossier, infrastructuurId, showBeads) {
	return function (dispatch) {
		let layout = getLayoutByDossierType(typeDossier);

		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;
		layout.disableTopNav = false;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = true;
		layout.sideNavPrefix = "/bovenlokaliteit/" + dossierId;

		layout.showBeads = showBeads;
		layout.hideAlgemeenButton = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadBeoordelingscriteriaPageLayout(title, subtitle, dossierId, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {

		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;

		const initialisatieOK = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = false;
		layout.showBeads = showBeads;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadIndienenPageLayout(dossierId, title, subtitle, initialisatieOK, dossierType, infrastructuurId, showBeads) {
	return function (dispatch) {
		let layout = getLayoutByDossierType(dossierType);
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = true;
		layout.topNavTabSettings = mergeDeep({}, layout.topNavTabSettings, getEnabledWithUrlTabs(dossierId, initialisatieOK, infrastructuurId));
		layout.showSideNav = false;
		layout.showBeads = showBeads;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadIndienenBevestigingPageLayout(dossierId, title, subtitle) { // will need dossierInitialised
	return function (dispatch) {

		let layout = getLayout();// will change to getEnabledWithUrlTabs(dossierId, dossierInitialised) for the story that allows reviewing tabs in disabled state
		layout.pageHeaderTitle = "Dossier " + title;
		layout.pageHeaderSubtitle = subtitle;
		layout.topNavTabSettings.indienenTab.disabled = false;
		layout.topNavTabSettings.indienenTab.urlSuffix = "/" + dossierId;
		layout.showTopNav = true;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSimulatieDossierPageLayout(title, intro, simulatieDossierId, showSideNav) {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = title;
		layout.pageHeaderIntro = intro;
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showSideNav = showSideNav;
		layout.sideNavPrefix = "/simulatiedossier/" + simulatieDossierId;
		layout.hideAlgemeenButton = (simulatieDossierId == null);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSimulatieInfrastructuurDetailPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showSideNav = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSimulatiePerInfrastructuurEditInfrastructuurLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showSideNav = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSimulatiePerInfrastructuurPageLayout(title, intro, simulatieDossierId, showSideNav) {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = title;
		layout.pageHeaderIntro = intro;
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showSideNav = showSideNav;
		layout.sideNavPrefix = "/simulatiedossier/" + simulatieDossierId;
		layout.hideAlgemeenButton = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSimulatieBevestigingsLayout(title, dossierId) {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = title;
		layout.pageHeaderIntro = "";
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.showSideNav = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadExceptionPageLayout() {
	return function (dispatch) {

		let layout = getLayout();
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.pageHeaderIntro = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

function getEnabledWithUrlTabs(dossierId, dossierInitialised, infrastructuurId) {
	const infra = infrastructuurId === undefined || infrastructuurId === null || infrastructuurId === '00000000-0000-0000-0000-000000000000' ? "" : "/infrastructuur/" + infrastructuurId;
	return ({
		dossierTab: { disabled: false, urlSuffix: "/" + dossierId },
		projectTab: { disabled: false, urlSuffix: "/" + dossierId },
		minimaleEisenTab: { disabled: !dossierInitialised, urlSuffix: "/" + dossierId + infra },
		financieelTab: { disabled: !dossierInitialised, urlSuffix: "/" + dossierId },
		bovenLokaliteitTab: { disabled: !dossierInitialised, urlSuffix: "/" + dossierId },
		beoordelingscriteriaTab: { disabled: !dossierInitialised, urlSuffix: "/" + dossierId },
		indienenTab: { disabled: false, urlSuffix: "/" + dossierId }
	});
}

function getDisabledWithUrlTabs(dossierId, dossierInitialised, infrastructuurId) {
	const infra = infrastructuurId === undefined || infrastructuurId === null || infrastructuurId === '00000000-0000-0000-0000-000000000000' ? "" : "/infrastructuur/" + infrastructuurId;
	return ({
		dossierTab: { disabled: true, urlSuffix: "/" + dossierId },
		projectTab: { disabled: true, urlSuffix: "/" + dossierId },
		minimaleEisenTab: { disabled: true, urlSuffix: "/" + dossierId + infra },
		financieelTab: { disabled: true, urlSuffix: "/" + dossierId },
		bovenLokaliteitTab: { disabled: true, urlSuffix: "/" + dossierId },
		beoordelingscriteriaTab: { disabled: true, urlSuffix: "/" + dossierId },
		indienenTab: { disabled: true, urlSuffix: "/" + dossierId }
	});
}

function getLayoutByDossierType(dossierType) {

	let layout = getLayout();
	let isDossierTypeTopsport = (dossierType === DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW || dossierType === DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE);

	const tabUrl = isDossierTypeTopsport ? "/beoordelingscriteriatopsport" : "/beoordelingscriteriabovenlokaal";
	layout.topNavTabSettings.beoordelingscriteriaTab.url = tabUrl;
	layout.topNavTabSettings.beoordelingscriteriaTab.visible = true;
	layout.showSideNavFinancieel = false;
	layout.sideNavItems = [];

	if (isDossierTypeTopsport) {
		layout.topNavTabSettings.bovenLokaliteitTab.disabled = true;
		layout.topNavTabSettings.bovenLokaliteitTab.visible = false;
	}
	else if (dossierType) {
		layout.topNavTabSettings.bovenLokaliteitTab.visible = true;
	}

	return layout;
}
